import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  puestoloading: false,
  unidadloading: false,
  saveLoader: false,
  segmentLength: 0,
  segment: [],
  puestoLength: 0,
  puesto: [],
  unidadLength: 0,
  unidad: [],
  segmentFormFail: null,
  loadingEmployees: false,
  employees: [],
};

export default function segmentReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_SEGMENT:
      return { ...state, loading: action.payload };
    case actions.LOADING_SEGMENT_EMPLOYEES:
      return { ...state, loadingEmployees: action.payload };
    case actions.LOADING_CLIMA_Funcional_PuestoXUnidad_Organizativa:
      return { ...state, puestoloading: action.payload };
    case actions.LOADING_CLIMA_Funcional_Unidad_OrganizativaXOrganizacion:
      return { ...state, unidadloading: action.payload };
    case actions.SAVE_LOADER_SEGMENT:
      return { ...state, saveLoader: action.payload };
    case actions.GET_SEGMENT:
      return {
        ...state,
        segment: action.payload.segment,
        segmentLength: action.payload.segmentLength,
      };
    case actions.GET_SEGMENT_EMPLOYEES:
      return {
        ...state,
        employees: action.payload,
      };
    case actions.GET_CLIMA_Funcional_PuestoXUnidad_Organizativa:
      return {
        ...state,
        puesto: action.payload.puesto,
        puestoLength: action.payload.puestoLength,
      };
    case actions.GET_CLIMA_Funcional_Unidad_OrganizativaXOrganizacion:
      return {
        ...state,
        unidad: action.payload.unidad,
        unidadLength: action.payload.unidadLength,
      };
    case actions.FORM_SEGMENT_FAIL:
      return { ...state, segmentFormFail: action.payload };
    default:
      return { ...state };
  }
}
